export default __webpack_public_path__ + "static/media/crisis-text-line.ddbc8786.jpeg";